/* ==========================================================================
   FLC Forge — Quick Add
   ========================================================================== */

class QuickAddButton extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('[data-quick-add-btn]');
    this.variantId = this.dataset.variantId;
    this.productUrl = this.dataset.productUrl;
    this.hasVariants = this.dataset.hasVariants === 'true';

    this.btn?.addEventListener('click', (e) => {
      e.preventDefault();
      this.hasVariants ? this.openModal() : this.addToCart();
    });
  }

  async addToCart() {
    if (!this.variantId) return;
    this.setLoading(true);

    try {
      const data = await FLC.fetchJSON(window.flcForge.routes.cart_add_url, {
        method: 'POST',
        body: JSON.stringify({ id: this.variantId, quantity: 1 })
      });
      FLC.dispatch('flc:cart:refresh');
      FLC.dispatch('flc:cart:open');
      window.liveRegion?.announce('Added to cart');
    } catch (err) {
      console.error('Quick add failed:', err);
    } finally {
      this.setLoading(false);
    }
  }

  openModal() {
    const modal = document.getElementById('quick-add-modal');
    if (modal) {
      modal.open(this.productUrl);
    } else {
      window.location.href = this.productUrl;
    }
  }

  setLoading(state) {
    if (this.btn) {
      this.btn.disabled = state;
      this.btn.setAttribute('aria-busy', state);
    }
  }
}

customElements.define('quick-add-button', QuickAddButton);

/* Quick Add Modal
   ========================================================================== */
class QuickAddModal extends HTMLElement {
  connectedCallback() {
    this.inner   = this.querySelector('[data-modal-inner]');
    this.closeBtn = this.querySelector('[data-modal-close]');

    this.closeBtn?.addEventListener('click', () => this.close());
    this.addEventListener('click', (e) => { if (e.target === this) this.close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    document.addEventListener('flc:drawers:close-all', () => this.close());
  }

  async open(productUrl) {
    try {
      const res = await fetch(`${productUrl}?sections=quick-add-form`);
      const json = await res.json();
      if (this.inner && json['quick-add-form']) {
        this.inner.innerHTML = json['quick-add-form'];
        // Re-init any custom elements inside
        this.inner.querySelectorAll('variant-selects, product-form').forEach(el => el.connectedCallback?.());
      }
    } catch (err) {
      console.error('Quick add modal load failed:', err);
    }

    this.setAttribute('aria-hidden', 'false');
    FLC.openOverlay();
    FLC.trapFocus(this);
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    FLC.closeOverlay();
    if (this.inner) this.inner.innerHTML = '';
  }
}

customElements.define('quick-add-modal', QuickAddModal);
